import { Controller } from "@hotwired/stimulus";
import { useTransition, useWindowResize } from "stimulus-use"

export default class extends Controller {
    static values = {
        'active': Boolean,
    }

    created = false

    connect() {
        useTransition(this, {
            enterActive: "transition will-change-transform ease-out duration-300",
            enterFrom: "transform-gpu opacity-0 translate-y-5",
            enterTo: "transform-gpu opacity-100 translate-y-0",
            leaveActive: "transition ease-in duration-300",
            leaveFrom: "transform-gpu opacity-100 translate-y-0",
            leaveTo: "transform-gpu opacity-0 -translate-y-5",
            transitioned: this.activeValue
        })

        this.created = true
    }

    activeValueChanged() {
        if (this.created) {
            this.activeValue
                ? this.enter()
                : this.leave()
        }
    }
}
